import type { SiteControllerSettingBaseFormModel } from "../../../../base/type";
import type { SiteControllerSettingNeppanFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
};

export const baseViewModelToViewModelConverter = ({ viewModel: _viewModel }: Props) => {
	const { isDirty, hasError, hotelID, password, setUpRoomPriceByChillnn } = _viewModel;

	const viewModel: SiteControllerSettingNeppanFormModel["ViewModel"] = {
		isDirty,
		hasError,

		hotelID,
		password,
		setUpRoomPriceByChillnn,
	};

	return { viewModel };
};
